import { render, staticRenderFns } from "./PiPortfolioSummaries.vue?vue&type=template&id=9a0df69c"
import script from "./PiPortfolioSummaries.vue?vue&type=script&lang=js"
export * from "./PiPortfolioSummaries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports